import { Button } from "@mui/material";

const InfoButton = ({ onClick, label }) => {
  return (
    <Button
      color="secondary"
      variant="contained"
      fullWidth={true}
      sx={{
        fontWeight: "bold",
      }}
      onClick={onClick}
    >
      { label }
    </Button>
  );
};

export default InfoButton;